import {
  ablaufEndColumn,
  ablaufStartColumn,
  akaVeranstaltungIdColumn,
  buchungsnummerColumn,
  expertsColumn,
  statusColumn,
  titelColumn,
  TrpcLoadingInfo,
  VeranstaltungenTable,
  veranstaltungSapIdColumn,
  vNummerColumn,
} from '../../../components/general';
import { type SearchVeranstaltungOutputItem } from '../../../dtos';
import { trpc } from '../../../trpc';
import { type DataGridColDef } from '../../../utils';

type VeranstaltungSearchProps = {
  readonly searchTerm: string;
};

export const VeranstaltungSearch = ({ searchTerm }: VeranstaltungSearchProps) => {
  const veranstaltungQuery = trpc.search.searchVeranstaltungen.useQuery(
    { searchTerm },
    { enabled: searchTerm.length > 0 },
  );

  const columns: DataGridColDef<SearchVeranstaltungOutputItem> = [
    veranstaltungSapIdColumn(),
    akaVeranstaltungIdColumn(),
    buchungsnummerColumn(),
    vNummerColumn(),
    titelColumn(),
    ablaufStartColumn(),
    ablaufEndColumn(),
    statusColumn(),
    expertsColumn(),
  ];

  return (
    <TrpcLoadingInfo trpcQuery={veranstaltungQuery} entity="Veranstaltungen">
      <VeranstaltungenTable
        columns={columns}
        veranstaltungen={veranstaltungQuery.data ?? []}
        getRowId={(veranstaltung) => veranstaltung.akaVeranstaltungId}
        pageSizeDefault={50}
      />
    </TrpcLoadingInfo>
  );
};
